import { getRegistryForObjectType } from './registry/getRegistryForObjectType';
export const prefetchBoardCardRegistry = (objectTypeId, appId) => {
  void getRegistryForObjectType(objectTypeId, appId);
};